window.Accordion = () => {
    return {
        openSection: 0,
    };
};
